import { signalStore, withState, withMethods, patchState, withComputed, withProps } from '@ngrx/signals';
import { computed, inject, resource } from '@angular/core';
import { SubmissionGridService } from './submission-grid.service';

export const SubmissionGridStore = signalStore(
  { providedIn: 'root' },
  withState<{filterValues: object}>({
    filterValues: <object>{},
  }),
  withComputed((state) => ({
    debug: computed(() => ({
      filterValues: state?.filterValues?.(),
    })),
  })),
  withMethods((store) => ({
    setFilterValues(value: object) {
      patchState(store, {
        filterValues: value,
      });
    },
  })),
  withProps((store, submissionGridService = inject(SubmissionGridService)) =>({
    resource: resource({
      request: store.filterValues,
      loader: async (request) => {
        const filter = request.request;
        const submissionGrid = await submissionGridService.getSubmissionGrid(filter);
        return submissionGrid;
      }
    })
  }))
);